document.addEventListener('DOMContentLoaded', function() {
  // Toast notification function
  function showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.className = `toast-notification toast-${type}`;
    toast.textContent = message;
    toast.style.position = 'fixed';
    toast.style.top = '20px';
    toast.style.right = '20px';
    toast.style.backgroundColor = type === 'success' ? '#4CAF50' : '#f44336';
    toast.style.color = 'white';
    toast.style.padding = '12px 24px';
    toast.style.borderRadius = '4px';
    toast.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
    toast.style.zIndex = '9999';
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.3s ease-in-out';
    
    document.body.appendChild(toast);
    
    // Trigger reflow to enable transition
    toast.offsetHeight;
    toast.style.opacity = '1';
    
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  }

  // Initialize selected products tracking with quantities and variants
  const selectedProducts = {
    collection_products: new Map(), 
    product_slider: new Map(),
    add_ons: new Map()
  };
  
  // Add to cart button reference
  const addToCartButton = document.getElementById('add-pack-to-cart');
  const originalPrices = new Map();

  // Function to get discount percentage based on number of items
  function getDiscountPercentage(itemCount) {
    if (itemCount >= 6) return 30;
    if (itemCount >= 5) return 25;
    if (itemCount >= 4) return 20;
    if (itemCount >= 3) return 15;
    return 10;
  }

  // Function to get discount percentage for total price
  function getDiscountPercentageForTotal(itemCount) {
    if (itemCount >= 7) return 30;
    if (itemCount >= 6) return 25;
    if (itemCount >= 5) return 20;
    if (itemCount >= 4) return 15;
    if (itemCount >= 3) return 10;
    return 10;
  }

  // Function to format price
  function formatPrice(price) {
    return `$${(parseFloat(price)).toFixed(2)}`;
  }

  // Function to update prices with discount
  function updateSelectedItemsGrid() {
    const selectedItemsGrid = document.getElementById('selected-items-grid');
    selectedItemsGrid.innerHTML = '';

    // Combine all selected products
    const allSelectedProducts = [
      ...Array.from(selectedProducts.collection_products.entries()),
      ...Array.from(selectedProducts.product_slider.entries()),
      ...Array.from(selectedProducts.add_ons.entries())
    ];

    // Create individual items for each quantity
    allSelectedProducts.forEach(([productId, variants]) => {
      variants.forEach((variant) => {
        // Create separate grid items for each quantity
        for (let i = 0; i < variant.quantity; i++) {
          const selectedItem = document.createElement('div');
          selectedItem.className = 'selected-item';
          selectedItem.innerHTML = `
            <img src="${variant.image}" alt="${variant.title}" class="selected-item__image">
            <div class="selected-item__info">
              <span class="selected-item__title">${variant.title}</span>
            </div>
            <button class="selected-item__remove" data-product-id="${productId}" data-variant-id="${variant.variantId}">&times;</button>
          `;
          selectedItemsGrid.appendChild(selectedItem);
        }
      });
    });
  }

  // Function to update prices with discount
  function updatePrices(shouldShowDiscountPopup = true, triggerEvent = null) { 
    // Count total items including quantities
    const totalSelectedItems = Array.from(selectedProducts.collection_products.values())
      .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    const addOnsCount = Array.from(selectedProducts.product_slider.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    const discountPercentage = getDiscountPercentage(collectionProductsCount);
    const addOnsDiscountPercentage = getDiscountPercentageForTotal(totalSelectedItems);

    // Show discount popup only when collection products count is 3 and the event is from collection products
    if (shouldShowDiscountPopup && collectionProductsCount === 3 && triggerEvent?.target) {
        const productCard = triggerEvent.target.closest('.product-card');
        const isCollectionProduct = productCard && getProductBlockType(productCard) === 'collection_products';
        if (isCollectionProduct && !triggerEvent.target.matches('#add-pack-to-cart')) {
            showDiscountPopup();
        }
    }

    // Update all product cards with product-level discount
    document.querySelectorAll('.product-card').forEach(card => {
      const priceElement = card.querySelector('.product-card__price');
      const productId = card.dataset.productId;
      const originalPrice = parseFloat(card.dataset.price);
      const blockType = getProductBlockType(card);
      
      if (priceElement && !isNaN(originalPrice)) {
        // Store original price if not already stored
        if (!originalPrices.has(productId)) {
          originalPrices.set(productId, originalPrice);
        }
        
        // Apply different discount rates based on product type
        const appliedDiscount = blockType === 'collection_products' ? discountPercentage : addOnsDiscountPercentage;
        const discountedPrice = originalPrice * (1 - appliedDiscount / 100);
        
        // Remove existing savings element if it exists
        const existingSavings = card.querySelector('.product-card__savings');
        if (existingSavings) existingSavings.remove();
  
        // Update price display
        priceElement.innerHTML = formatPrice(discountedPrice);
  
        // Show savings if there's a discount
        if (appliedDiscount > 0) {
          const savingsElement = document.createElement('div');
          savingsElement.className = 'product-card__savings';
          savingsElement.style.color = 'red';
          savingsElement.textContent = `Save ${appliedDiscount}%`;
          priceElement.insertAdjacentElement('afterend', savingsElement);
        }
      }
    });
  
    // Update total price with detailed logging and total-specific discount
    let total = 0;
    let priceDetails = {};
  
    Object.entries(selectedProducts).forEach(([category, productMap]) => {
      priceDetails[category] = [];
      productMap.forEach((variants, productId) => {
        variants.forEach(variant => {
          if (variant.price) {
            const itemDiscount = category === 'collection_products' ? discountPercentage : addOnsDiscountPercentage;
            const itemTotal = variant.price * variant.quantity * (1 - itemDiscount / 100);
            total += itemTotal;
            priceDetails[category].push({
              variantId: variant.variantId,
              quantity: variant.quantity,
              originalPrice: variant.price,
              discountedTotal: itemTotal
            });
          }
        });
      });
    });
  
    // Update price elements with the calculated total
    const totalPriceElement = document.getElementById('entertainment-pack-total-price');
    const mainPriceElement = document.getElementById('entertainment-pack-price');
  
    // Ensure price elements are updated with formatted total
    if (totalPriceElement) {
      totalPriceElement.textContent = formatPrice(total);
    }
    if (mainPriceElement) {
      mainPriceElement.textContent = formatPrice(total);
    }
  
    // Update selected items grid
    updateSelectedItemsGrid();
  }

  // Add to cart button click handler
  if (addToCartButton) {
    addToCartButton.addEventListener('click', async () => {
      // Check requirements before proceeding
      const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
      const productSliderCount = Array.from(selectedProducts.product_slider.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
      
      const requirementsMet = collectionProductsCount >= 3 && productSliderCount >= 1;
      
      if (!requirementsMet) {
        showRequirementsPopup();
        return;
      }

      // Disable button to prevent double submission
      addToCartButton.disabled = true;
      addToCartButton.classList.add('loading');

      const items = [];
      let hasError = false;

      // Build cart items from selected products
      Object.values(selectedProducts).forEach(productMap => {
        productMap.forEach((variants, productId) => {
          variants.forEach(variant => {
            if (variant.variantId) {
              items.push({
                id: parseInt(variant.variantId),
                quantity: variant.quantity
              });
            } else {
              hasError = true;
            }
          });
        });
      });

      if (hasError || items.length === 0) {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('loading');
        alert('There was an error with your selection. Please try again.');
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Failed to add items to cart');
        }

        // Calculate total items for discount based on collection products only
        const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
          .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
        const discountPercentage = getDiscountPercentageForTotal(collectionProductsCount);

        // Successfully added to cart
        // window.location.href = `/checkout?discount=BUNDLE${discountPercentage}EX`;
        window.location.href = `/checkout`;
      } catch (error) {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('loading');
        alert(error.message || 'Failed to add items to cart. Please try again.');
      }
    });
  }

  // Check if minimum products are selected and show appropriate message
  function checkMinimumRequirements() {
    if (addToCartButton) {
      // Count variants with quantities and log details
      const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
      const productSliderCount = Array.from(selectedProducts.product_slider.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
      const addOnsCount = Array.from(selectedProducts.add_ons.values())
        .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
      
      // Check if requirements are met
      const requirementsMet = collectionProductsCount >= 3 && productSliderCount >= 1;
      
      return requirementsMet;
    }
    return false;
  }
  // Function to show discount popup
  function showDiscountPopup() {
    const modal = document.getElementById('discount-modal');
    const modalTitle = modal.querySelector('.discount-modal__title');
    const modalContent = modal.querySelector('.discount-modal__tiers');
  
    if (!modal || !modalTitle || !modalContent) {
      return;
    }
  
    // Get total selected items count
    const totalSelectedItems = Array.from(selectedProducts.collection_products.values())
      .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
  
    modalTitle.textContent = 'Want to save even more?';
    modalContent.innerHTML = `
      <div class="discount-tier"><span class="discount-tier__condition">Select 1 more item receive 15% off</span></div>
      <div class="discount-tier"><span class="discount-tier__condition">Select 2 more items receive 20% off</span></div>
      <div class="discount-tier"><span class="discount-tier__condition">Select 3 more items receive 25% off</span></div>
      <div class="discount-tier"><span class="discount-tier__condition">Select 4 or more items receive 30% off</span></div>
    `;
  
    modal.style.display = 'flex';
    setTimeout(() => {
      modal.classList.add('active');
    }, 10);
  }

  // Function to show variant popup
  function showVariantPopup(productCard, button) {
    const variantPopup = document.querySelector('.variant-popup');
    const variantsContainer = variantPopup.querySelector('.variant-popup__variants');
    
    // Clear previous variants and add header
    variantsContainer.innerHTML = '';
    
    // Position popup below the product card
    const rect = productCard.getBoundingClientRect();
    variantPopup.style.top = `${rect.bottom + window.scrollY + 10}px`;
    variantPopup.style.left = `${rect.left}px`;
    
    // Get variants data from data attribute
    const variants = JSON.parse(productCard.dataset.variants || '[]');
    
    // Create variants grid container with improved layout
    const variantsGrid = document.createElement('div');
    variantsGrid.className = 'variant-popup__grid';
    variantsGrid.style.display = 'grid';
    variantsGrid.style.gridTemplateColumns = 'repeat(auto-fit, minmax(120px, 1fr))';
    variantsGrid.style.gap = '10px';
    variantsGrid.style.padding = '10px';
    variantsGrid.style.width = '100%';
    variantsGrid.style.maxWidth = '300px';
    
    // Add variant options
    variants.forEach(variant => {
      const variantOption = document.createElement('div');
      variantOption.className = 'variant-option';
      variantOption.dataset.variantId = variant.id;
      variantOption.dataset.price = variant.price / 100; // Convert cents to dollars
      variantOption.style.cursor = variant.available ? 'pointer' : 'not-allowed';
      
      // Get variant image if available
      const variantImage = variant.featured_image?.src || productCard.dataset.image1;
      
      variantOption.innerHTML = `
        <img class="variant-option__image" src="${variantImage}" alt="${variant.title}" style="width: 100%; height: 120px; object-fit: cover; border-radius: 6px;">
        <div class="variant-option__info" style="text-align: center; margin-top: 6px;">
          <h4 class="variant-option__title" style="margin: 0; font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${variant.title}</h4>
          ${variant.available ? '' : '<div class="variant-option__sold-out" style="color: red; font-size: 12px;">Sold Out</div>'}
        </div>
      `;
      
      if (!variant.available) {
        variantOption.classList.add('sold-out');
        variantOption.style.opacity = '0.6';
      }
      
      variantOption.addEventListener('click', (event) => {
        if (!variant.available) return;
        
        const productId = productCard.dataset.productId;
        const price = parseFloat(variant.price) / 100;
        const productTitle = productCard.dataset.title || 'Product';
        const blockType = getProductBlockType(productCard);

        // Check if this is a slider product and if another one is already selected
        if (blockType === 'product_slider' && selectedProducts.product_slider.size > 0) {
          showToast('Only 1 free bag can be selected, please remove other before adding', type="warning");
          return;
        }
        
        // Store original price
        if (!originalPrices.has(productId)) {
          originalPrices.set(productId, price);
        }
        
        // Add or update product in selectedProducts
        if (!selectedProducts[blockType].has(productId)) {
          selectedProducts[blockType].set(productId, []);
        }
        
        // Check if variant already exists
        const existingVariantIndex = selectedProducts[blockType].get(productId).findIndex(v => v.variantId === parseInt(variant.id));
        
        if (existingVariantIndex !== -1) {
          // Increment quantity if variant exists
          selectedProducts[blockType].get(productId)[existingVariantIndex].quantity++;
          showToast(`Added another ${productTitle} - ${variant.title}`);
        } else {
          // Add new variant selection
          selectedProducts[blockType].get(productId).push({
            variantId: parseInt(variant.id),
            quantity: 1,
            price: price,
            image: variantImage,
            title: variant.title
          });
          showToast(`Added ${productTitle} - ${variant.title}`);
        }
        
        // Update variant ID and price
        productCard.dataset.variantId = variant.id;
        productCard.dataset.price = price;
        
        // Update UI
        button.style.display = 'none';
        productCard.querySelector('.product-remove-button').style.display = 'block';
        // Only show add-more button if not a slider product
        if (blockType !== 'product_slider') {
          productCard.querySelector('.add-more-button').style.display = 'block';
        }
        productCard.classList.add('selected_item');
        
        // Hide popup
        variantPopup.classList.remove('active');
        variantPopup.style.display = 'none';
        
        // Create a synthetic event with the product card as target
        const syntheticEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        Object.defineProperty(syntheticEvent, 'target', { value: productCard });
        
        // Update prices and requirements
        updatePrices(true, syntheticEvent);
        checkMinimumRequirements();
      });
      
      variantsGrid.appendChild(variantOption);
    });
    
    variantsContainer.appendChild(variantsGrid);
    
    // Show popup with styling
    variantPopup.style.display = 'block';
    variantPopup.style.backgroundColor = '#fff';
    variantPopup.style.borderRadius = '12px';
    variantPopup.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
    variantPopup.style.minWidth = '300px';
    setTimeout(() => variantPopup.classList.add('active'), 10);
  }

  // Event listener for add/remove buttons
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-add-button') || event.target.classList.contains('add-more-button')) {
      const productCard = event.target.closest('.product-card');
      const hasVariants = productCard.dataset.hasVariants === 'true';
      const blockType = getProductBlockType(productCard);
      
      // Check if this is a slider product and if another one is already selected
      if (blockType === 'product_slider' && selectedProducts.product_slider.size > 0) {
        showToast('Only 1 free bag can be selected, please remove other before adding', type="warning");
        return;
      }
      
      if (hasVariants) {
        event.preventDefault();
        event.stopPropagation();
        showVariantPopup(productCard, event.target);
        return;
      } else {
        const productId = productCard.dataset.productId;
        const price = parseFloat(productCard.dataset.price);
        const productTitle = productCard.dataset.title || 'Product';
        const productImage = productCard.dataset.image1 || '';

        // Store original price if not already stored
        if (!originalPrices.has(productId)) {
          originalPrices.set(productId, price);
        }
        
        // Initialize array for this product if it doesn't exist
        if (!selectedProducts[blockType].has(productId)) {
          selectedProducts[blockType].set(productId, []);
        }
        
        // Check if non-variant product already exists
        const existingProductIndex = selectedProducts[blockType].get(productId).findIndex(v => v.variantId === parseInt(productCard.dataset.variantId));
        
        if (existingProductIndex !== -1) {
          // Increment quantity if product exists
          selectedProducts[blockType].get(productId)[existingProductIndex].quantity++;
          showToast(`Added another ${productTitle}`);
        } else {
          // Add the non-variant product as a single variant
          selectedProducts[blockType].get(productId).push({
            variantId: parseInt(productCard.dataset.variantId),
            quantity: 1,
            price: price,
            image: productImage,
            title: productTitle
          });
          showToast(`Added ${productTitle}`);
        }

        // Update UI
        const addButton = productCard.querySelector('.product-add-button');
        const removeButton = productCard.querySelector('.product-remove-button');
        const addMoreButton = productCard.querySelector('.add-more-button');

        if (addButton) addButton.style.display = 'none';
        if (removeButton) removeButton.style.display = 'block';
        if (addMoreButton) addMoreButton.style.display = blockType !== 'product_slider' ? 'block' : 'none';
        
        productCard.classList.add('selected_item');
        updatePrices(true, event);
        checkMinimumRequirements();
      }
    }

    // Event listener for remove buttons
    if (event.target.classList.contains('product-remove-button')) {
      const productCard = event.target.closest('.product-card');
      const productId = productCard.dataset.productId;
      const blockType = getProductBlockType(productCard);
      
      // Remove from product card - remove all variants
      selectedProducts[blockType].delete(productId);
      showToast(`Removed ${productCard.dataset.title}`, 'error');
      
      // Update UI
      const addButton = productCard.querySelector('.product-add-button');
      const removeButton = productCard.querySelector('.product-remove-button');
      const addMoreButton = productCard.querySelector('.add-more-button');
      
      if (addButton) addButton.style.display = 'block';
      if (removeButton) removeButton.style.display = 'none';
      if (addMoreButton) addMoreButton.style.display = 'none';
      productCard.classList.remove('selected_item');
    } else if (event.target.classList.contains('selected-item__remove')) {
      // Remove from selected items grid
      const productId = event.target.dataset.productId;
      const variantId = parseInt(event.target.dataset.variantId);
      const productCard = document.querySelector(`.product-card[data-product-id="${productId}"]`);
      const blockType = getProductBlockType(productCard);
      const variants = selectedProducts[blockType].get(productId) || [];
      
      const variantIndex = variants.findIndex(v => v.variantId === variantId);
      if (variantIndex !== -1) {
        const variant = variants[variantIndex];
        const productTitle = productCard.dataset.title || 'Product';
        
        if (variant.quantity > 1) {
          variant.quantity--;
          showToast(`Removed one ${productTitle} - ${variant.title}`, 'error');
        } else {
          variants.splice(variantIndex, 1);
          if (variants.length === 0) {
            selectedProducts[blockType].delete(productId);
            // Reset product card UI
            if (productCard) {
              const addButton = productCard.querySelector('.product-add-button');
              const removeButton = productCard.querySelector('.product-remove-button');
              const addMoreButton = productCard.querySelector('.add-more-button');
              
              if (addButton) addButton.style.display = 'block';
              if (removeButton) removeButton.style.display = 'none';
              if (addMoreButton) addMoreButton.style.display = 'none';
              productCard.classList.remove('selected_item');
            }
          }
          showToast(`Removed ${productTitle} - ${variant.title}`, 'error');
        }
      }
    }

    // Update prices and check requirements
    updatePrices();
    checkMinimumRequirements();
  });

  // Close modal when clicking the close button
  document.querySelectorAll('.modal__close').forEach(function(closeButton) {
    closeButton.addEventListener('click', function() {
      const modal = this.closest('.modal');
      modal.classList.remove('active');
      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);
    });
  });

  // Close modal and variant popup when clicking outside
  window.addEventListener('click', function(event) {
    const modals = document.querySelectorAll('.modal');
    const variantPopup = document.querySelector('.variant-popup');

    // Handle modals
    modals.forEach(modal => {
      if (event.target === modal) {
        modal.classList.remove('active');
        setTimeout(() => {
          modal.style.display = 'none';
        }, 300);
      }
    });

    // Handle variant popup
    if (variantPopup && variantPopup.style.display === 'block') {
      const isClickInside = variantPopup.contains(event.target) || 
                           event.target.classList.contains('product-add-button');
      
      if (!isClickInside) {
        variantPopup.classList.remove('active');
        setTimeout(() => {
          variantPopup.style.display = 'none';
        }, 300);
      }
    }
  });

  // Collection switching functionality
  const collectionCards = document.querySelectorAll('.collection-card');
  const productGrids = document.querySelectorAll('.collection-products-grid');

  // Function to determine product block type
  function getProductBlockType(productCard) {
    // Check for product slider first
    if (productCard.closest('.entertainment-pack-slider.swiper')) {
      return 'product_slider';
    }
    // Check for add-ons
    if (productCard.closest('#add-ons-products-grid')) {
      return 'add_ons';
    }
    // Default to collection products
    return 'collection_products';
  }
  
  // Show initial collection grid (first one)
  if (productGrids.length > 0) {
    productGrids[0].classList.remove('hidden');
    collectionCards[0]?.classList.add('active');
  }
  
  // Handle collection card click
  collectionCards.forEach(card => {
    card.addEventListener('click', function() {
      const collectionHandle = this.dataset.collectionHandle;
      
      // Update active state
      collectionCards.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      
      // Hide all grids and show the selected one
      productGrids.forEach(grid => {
        if (grid.dataset.collectionHandle === collectionHandle) {
          grid.classList.remove('hidden');
        } else {
          grid.classList.add('hidden');
        }
      });
    });
  });


  // Check if minimum products are selected and show appropriate message
  function checkMinimumRequirements() {
    if (addToCartButton) {
      // Count variants, not just product IDs
      const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
        .reduce((sum, variants) => sum + variants.length, 0);
      const productSliderCount = Array.from(selectedProducts.product_slider.values())
        .reduce((sum, variants) => sum + variants.length, 0);
      const addOnsCount = Array.from(selectedProducts.add_ons.values())
        .reduce((sum, variants) => sum + variants.length, 0);
      
      // Check if requirements are met
      const requirementsMet = collectionProductsCount >= 3 && productSliderCount >= 1;
      
      // Update total price including add-ons
      updateTotalPrice();
      return requirementsMet;
    }
    return false;
  }

  // Calculate and update total price
  function updateTotalPrice() {
    let total = 0;
    // Count total variants for discount calculation including quantities
    const totalSelectedItems = Array.from(selectedProducts.collection_products.values())
      .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    const discountPercentage = getDiscountPercentage(totalSelectedItems);
    const totalDiscountPercentage = getDiscountPercentageForTotal(totalSelectedItems);
    
    // Process all product variants from all sections
    Object.values(selectedProducts).forEach(productMap => {
      productMap.forEach((variants, productId) => {
        variants.forEach(variant => {
          if (variant.price && !isNaN(variant.price)) {
            const itemTotal = variant.price * variant.quantity * (1 - totalDiscountPercentage / 100);
            total += itemTotal;
          }
        });
      });
    });

    // Update price displays
    const priceDisplays = ['entertainment-pack-price', 'entertainment-pack-total-price'];
    priceDisplays.forEach(displayId => {
      const display = document.getElementById(displayId);
      if (display) {
        display.textContent = formatPrice(total);
      }
    });

    // Update selected items grid to reflect quantities
    updateSelectedItemsGrid();
  }



  // Initialize Swipers
  const productSlider = new Swiper('.entertainment-pack-slider.product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next.product-slider',
      prevEl: '.swiper-button-prev.product-slider',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });

  const collectionSlider = new Swiper('.entertainment-pack-slider.collection-slider', {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next.collection-slider',
      prevEl: '.swiper-button-prev.collection-slider',
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });

  // Modal functionality
  const modal = document.getElementById('product-modal');
  const modalImage1 = document.getElementById('modal-image-1');
  const modalImage2 = document.getElementById('modal-image-2');
  const modalTitle = document.getElementById('modal-title');
  const modalDescription = document.getElementById('modal-description');
  const closeButton = modal.querySelector('.modal__close');

  document.querySelectorAll('.see-more-button').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const productCard = button.closest('.product-card');
      
      // Update modal content
      modalImage1.src = productCard.dataset.image1;
      modalImage1.alt = productCard.dataset.title;
      
      if (productCard.dataset.image2) {
        modalImage2.src = productCard.dataset.image2;
        modalImage2.alt = productCard.dataset.title;
        modalImage2.style.display = 'block';
      } else {
        modalImage2.style.display = 'none';
      }
      
      modalTitle.textContent = productCard.dataset.title;
      modalDescription.innerHTML = productCard.dataset.description;
      
      // Show modal
      modal.style.display = 'flex';
      setTimeout(() => {
        modal.classList.add('active');
      }, 10);
    });
  });

  closeButton.addEventListener('click', () => {
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.display = 'none';
    }, 300);
  });

  // Function to show requirements popup
  function showRequirementsPopup() {
    const collectionProductsCount = Array.from(selectedProducts.collection_products.values())
      .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    const productSliderCount = Array.from(selectedProducts.product_slider.values())
      .reduce((sum, variants) => sum + variants.reduce((vSum, v) => vSum + v.quantity, 0), 0);
    
    const remainingCollection = Math.max(0, 3 - collectionProductsCount);
    const remainingSlider = Math.max(0, 1 - productSliderCount);

    const modal = document.getElementById('discount-modal');
    const modalTitle = modal.querySelector('.discount-modal__title');
    const modalContent = modal.querySelector('.discount-modal__tiers');

    modalTitle.textContent = `Whoops! You're missing some items!`;
    modalContent.innerHTML = `
      <div class="requirements-message">
        <p>Step One - Add ${remainingSlider} items</P>
        <p>Step Three - Add ${remainingCollection} items</p>        
      </div>
    `;

    modal.style.display = 'flex';
    setTimeout(() => {
      modal.classList.add('active');
    }, 10);
  }
});